import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { BsPlayCircle } from "react-icons/bs";
import posDeviceData from "../../lib/Json/prouctData.json";

function ProductDetails() {
  const { id } = useParams();
  const containerRef = useRef(null);
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  useEffect(() => {
    setSelectedImageId(selectedProduct.images[0].id);
    setSelectedImage(selectedProduct.images[0].url);
  }, [id]);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(false);

  const selectedProduct = posDeviceData?.find((product) => product.id === id);

  if (!selectedProduct) {
    return (
      <h2 className="text-center text-xl poppins_bold">Product Not Found</h2>
    );
  }

  const handleImageClick = (imgData) => {
    setSelectedFileType(imgData.isVideo);
    setSelectedImageId(imgData.id);
    setSelectedImage(imgData.url);
  };
  const mainFeatures = Object.entries(selectedProduct.mainFeature);
  const mainSpecifications = Object.entries(selectedProduct.specification);

  const handleMouseDown = (e) => {
    setIsMouseDown(true);
    setStartX(e.clientX);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsMouseDown(false);
  };

  const handleMouseUp = () => {
    setIsMouseDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isMouseDown) return;
    const x = e.clientX - startX;
    containerRef.current.scrollLeft = scrollLeft - x;
  };
  return (
    <section className="bg-white text-black antialiased">
      <div className="px-4 lg:max-w-[1300px] mx-auto 2xl:px-0">
        <div className="lg:grid lg:grid-cols-2 gap-2 relative">
          <div className="shrink-0 w-full mx-auto overflow-hidden h-full">
            <div className="w-full sm:px-4 mb-8 flex gap-5">
              <div className="flex flex-col w-1/4 h-80 sm:h-[35rem] gap-4 overflow-auto scrollbar-hide">
                {selectedProduct.images.map((img, index) => {
                  const getYouTubeVideoId = (url) => {
                    const regExp =
                      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|youtu\.be\/)([^#\&\?]*).*/;
                    const match = url.match(regExp);
                    return match && match[2].length === 11 ? match[2] : null;
                  };

                  const videoId = getYouTubeVideoId(img.url);
                  const thumbnailUrl = videoId
                    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
                    : null;
                  return (
                    <div
                      key={index}
                      className={`${img.id === selectedImageId ? "border border-[#2874F0] rounded-lg transition-all duration-300" : "border border-transparent"}`}
                      onClick={() => handleImageClick(img)}
                    >
                      {img.isVideo ? (
                        <div className="relative flex justify-center items-center mx-auto">
                          <img
                            alt="Product thumbnail"
                            src={thumbnailUrl}
                            className="w-fit h-12 sm:h-24 object-contain"
                          />
                          <div className="absolute top-0 left-0 right-0 bottom-0" />
                          <BsPlayCircle className="text-white text-4xl absolute inset-0 m-auto flex items-center justify-center" />
                        </div>
                      ) : (
                        <img
                          alt="Product thumbnail"
                          src={img.url}
                          className="w-full h-12 sm:h-24 object-contain"
                        />
                      )}
                    </div>
                  );
                })}
              </div>

              <div
                aria-label="product image"
                className="h-80 sm:h-[35rem] w-[30rem] overflow-hidden flex items-center justify-center m-auto"
              >
                {selectedFileType ? (
                  <iframe
                    title="Image"
                    src={selectedImage}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    className="w-full h-full object-contain"
                    allowfullscreen
                  ></iframe>
                ) : (
                  <img
                    src={selectedImage}
                    alt="Product"
                    className="w-full h-full object-contain"
                    id="mainImage"
                  />
                )}
              </div>
            </div>
          </div>

          <div className="lg:max-w-[768px] scrollbar-hide lg:overflow-y-auto lg:max-h-screen lg:overflow-hidden lg:scrolling-touch mt-6 sm:mt-8 lg:mt-0 p-3 lg:p-10">
            <span className="text-green-800 bg-green-300 rounded-sm px-2 text-xs">
              In Stock
            </span>
            <h1 className="text-xl poppins_semibold text-gray-900 sm:text-2xl">
              {selectedProduct.ecommerceName}
            </h1>
            <h1 className="text-xl poppins_semibold text-gray-900 sm:text-2xl mt-5 text-center">
              {selectedProduct?.inBox}
            </h1>
            <hr className="my-3 md:my-4 border-gray-200 dark:border-gray-800" />
            <div className="text-xs sm:text-base poppins_light">
              {mainFeatures.map(([label, value], index) => (
                <div key={index} className="flex">
                  <div className="poppins_semibold w-1/2">{label}</div>
                  <div className="w-1/2">{value}</div>
                </div>
              ))}
            </div>
            <hr className="my-6 md:my-8 border-gray-200 dark:border-gray-800" />
            <h4 className="text-xl poppins_semibold">About this item</h4>
            <ul className="list-disc ml-5 py-4 space-y-1 poppins_light">
              {selectedProduct?.aboutItem?.map((item, index) => (
                <li
                  key={index}
                  className="text-[#C2C2C2] leading-5 tracking-wide text-justify"
                >
                  <span className="text-black">{item}</span>
                </li>
              ))}
            </ul>
            <div>
              <img src={selectedProduct?.applicableFor} alt="product" />
            </div>
          </div>
        </div>
        <hr className="my-6 md:my-8 border-gray-200 dark:border-gray-800" />
        <div>
          <h4 className="text-xl poppins_semibold mb-5">Specification</h4>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {mainSpecifications.map(([label, value], index) => {
              const formattedContent = value.replace(/\n/g, "<br />");
              return (
                <div key={index}>
                  <div className="flex border-y h-full">
                    <div className="poppins_semibold w-1/3 sm:w-1/4 bg-[#F0F2F2] py-2 pl-1 sm:pl-5 text-[9px] sm:text-base text-ellipsis overflow-hidden whitespace-nowrap">
                      {label}
                    </div>
                    <div
                      className="w-3/4 px-5 text-[9px] sm:text-base poppins_ligh content-center"
                      dangerouslySetInnerHTML={{ __html: formattedContent }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <hr className="my-6 md:my-8 border-gray-200 dark:border-gray-800" />
        <h4 className="text-xl poppins_semibold mb-5">Related Devices</h4>
        <div
          className="relative"
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <div
            ref={containerRef}
            className="flex overflow-x-auto scrollbar-hide"
          >
            {selectedProduct.similarProduct.map((product) => (
              <Link
                className="group text-center relative flex-shrink-0 mr-4 select-none bg-gray-100"
                key={product.id}
                to={`/product/${product.id}`}
              >
                <img
                  className="object-contain w-40 h-40 mx-auto select-none"
                  src={product.productImage}
                  alt={product.name}
                />
                <p className="text-gray-900 poppins_medium group-hover:text-[#2874F0] transition-all duration-300">
                  {product.name}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductDetails;
